(function () {
  'use strict';

  var CONTAINER_ID = 'rug-pad-upsell';
  var OPTIONS_ID = 'rug-pad-options';
  var PAD_DATA_ID = 'rug-pad-data';
  var VARIANT_MAP_ID = 'rug-variant-map';
  var SIZE_SELECT_ID = 'rug-pad-size-select';

  // ── Size parsing ──────────────────────────────────────────────────────
  function parseSize(title) {
    if (!title) return null;
    var normalized = title.toLowerCase();
    if (normalized.indexOf(' x ') === -1) return null;
    var parts = normalized.split(' x ');
    if (parts.length !== 2) return null;
    var w = parseDimension(parts[0].trim());
    var h = parseDimension(parts[1].trim());
    if (w === null || h === null) return null;
    if (w < 24 || h < 24) return null;
    return { wInches: w, hInches: h };
  }

  function parseDimension(str) {
    var match = str.match(/^(\d+)'[\s-]*(\d+)"?$/);
    if (match) return parseInt(match[1], 10) * 12 + parseInt(match[2], 10);
    match = str.match(/^(\d+)'$/);
    if (match) return parseInt(match[1], 10) * 12;
    match = str.match(/^(\d+)"$/);
    if (match) return parseInt(match[1], 10);
    return null;
  }

  // ── Size mapping ──────────────────────────────────────────────────────
  var SIZE_MAP = {
    '24x36': [24, 48], '24x96': [24, 96], '30x96': [24, 96],
    '30x90': [24, 96], '30x144': [24, 96], '36x60': [36, 60],
    '42x66': [48, 72], '43x67': [48, 72], '48x72': [48, 72],
    '60x84': [60, 96], '60x90': [60, 96], '60x91': [60, 96],
    '60x96': [60, 96], '63x93': [60, 96], '63x94': [60, 96],
    '72x108': [72, 108], '84x108': [96, 120], '84x120': [96, 120],
    '90x114': [96, 120], '91x115': [96, 120], '93x117': [96, 120],
    '94x118': [96, 120], '95x119': [96, 120], '96x120': [96, 120],
    '96x132': [96, 132], '102x138': [108, 144], '102x139': [108, 144],
    '103x139': [108, 144], '108x144': [108, 144], '108x156': [120, 168],
    '115x150': [120, 168], '117x162': [120, 168], '118x163': [120, 168],
    '120x168': [120, 168], '138x186': [144, 216], '139x187': [144, 216],
    '144x180': [144, 180], '144x216': [144, 216],
  };

  var STANDARD_WIDTHS = [24, 36, 48, 60, 72, 96, 108, 120, 144];
  var STANDARD_HEIGHTS = [48, 60, 72, 96, 108, 120, 132, 144, 168, 180, 216];

  function findPadSize(rugSize) {
    if (!rugSize) return null;
    var key = rugSize.wInches + 'x' + rugSize.hInches;
    if (SIZE_MAP[key]) {
      return { wInches: SIZE_MAP[key][0], hInches: SIZE_MAP[key][1] };
    }
    var padW = roundUpToNearest(rugSize.wInches, STANDARD_WIDTHS);
    var padH = roundUpToNearest(rugSize.hInches, STANDARD_HEIGHTS);
    if (padW === null || padH === null) return null;
    return { wInches: padW, hInches: padH };
  }

  function roundUpToNearest(value, sizes) {
    for (var i = 0; i < sizes.length; i++) {
      if (sizes[i] >= value) return sizes[i];
    }
    return null;
  }

  // ── Price formatting ──────────────────────────────────────────────────
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ── UI rendering ──────────────────────────────────────────────────────
  function renderOptions(matches, optionsEl) {
    if (!matches.length) {
      optionsEl.innerHTML = '';
      return;
    }

    var html = '';

    html += '<div class="rug-pad-upsell__option">';
    html += '<input type="radio" name="rug-pad-variant" id="rug-pad-none" value="" checked>';
    html += '<label for="rug-pad-none">';
    html += '<span class="rug-pad-upsell__radio-circle"></span>';
    html += '<span class="rug-pad-upsell__option-details">';
    html += '<span class="rug-pad-upsell__option-name">No rug pad</span>';
    html += '</span>';
    html += '</label>';
    html += '</div>';

    for (var i = 0; i < matches.length; i++) {
      var m = matches[i];
      var inputId = 'rug-pad-' + m.variantId;
      var disabled = !m.available;

      html += '<div class="rug-pad-upsell__option' + (disabled ? ' rug-pad-upsell__option--disabled' : '') + '">';
      html += '<input type="radio" name="rug-pad-variant" id="' + inputId + '" value="' + m.variantId + '"' + (disabled ? ' disabled' : '') + '>';
      html += '<label for="' + inputId + '">';
      html += '<span class="rug-pad-upsell__radio-circle"></span>';
      html += '<span class="rug-pad-upsell__option-details">';
      html += '<span class="rug-pad-upsell__option-name">' + m.padTitle + '</span>';
      html += '<span class="rug-pad-upsell__option-tag">' + m.surface + '</span>';
      if (disabled) {
        html += '<span class="rug-pad-upsell__option-stock">Out of Stock</span>';
      } else {
        html += '<span class="rug-pad-upsell__option-price">' + formatMoney(m.price) + '</span>';
      }
      html += '</span>';
      html += '</label>';
      html += '</div>';
    }

    optionsEl.innerHTML = html;
  }

  // ── Get selected pad variant ID ───────────────────────────────────────
  function getSelectedPadVariantId() {
    var checked = document.querySelector('input[name="rug-pad-variant"]:checked');
    if (!checked || !checked.value) return null;
    return parseInt(checked.value, 10);
  }

  // ── Accordion toggle ──────────────────────────────────────────────────
  function initAccordion(container) {
    var header = container.querySelector('.rug-pad-upsell__header');
    var body = container.querySelector('.rug-pad-upsell__body');
    if (!header || !body) return;
    header.addEventListener('click', function () {
      var expanded = header.getAttribute('aria-expanded') === 'true';
      header.setAttribute('aria-expanded', String(!expanded));
      body.setAttribute('aria-hidden', String(expanded));
    });
  }

  // ── Cart intercept ────────────────────────────────────────────────────
  var cartInterceptInstalled = false;
  function installCartIntercept() {
    if (cartInterceptInstalled) return;
    cartInterceptInstalled = true;
    var originalFetch = window.fetch;

    window.fetch = function (url, options) {
      if (
        typeof url === 'string' &&
        url.indexOf('/cart/add') !== -1 &&
        options &&
        options.method === 'POST' &&
        options.body instanceof FormData
      ) {
        var padVariantId = getSelectedPadVariantId();
        if (padVariantId) {
          var formData = options.body;
          var rugVariantId = formData.get('id');
          var quantity = parseInt(formData.get('quantity'), 10) || 1;
          var rugItem = { id: parseInt(rugVariantId, 10), quantity: quantity };

          var props = {};
          var entries = Array.from(formData.entries());
          for (var i = 0; i < entries.length; i++) {
            if (entries[i][0].indexOf('properties[') === 0) {
              var propName = entries[i][0].match(/\[(.+)\]/);
              if (propName) props[propName[1]] = entries[i][1];
            }
          }
          if (Object.keys(props).length > 0) rugItem.properties = props;

          var padItem = { id: padVariantId, quantity: 1 };

          return originalFetch.call(window, url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/javascript',
            },
            body: JSON.stringify({ items: [rugItem, padItem] }),
          });
        }
      }
      return originalFetch.apply(window, arguments);
    };
  }

  // ── Setup ─────────────────────────────────────────────────────────────
  function setup(container, optionsEl, padProducts) {
    initAccordion(container);
    installCartIntercept();

    // Build pad size lookup: parse all pad variants, group by size
    // Key: "WxH" in inches, Value: { label, matches[] }
    var padSizeGroups = {};

    for (var p = 0; p < padProducts.length; p++) {
      var product = padProducts[p];
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        var varSize = parseSize(variant.title);
        if (!varSize) continue;

        var key = varSize.wInches + 'x' + varSize.hInches;
        if (!padSizeGroups[key]) {
          padSizeGroups[key] = {
            label: variant.title,
            wInches: varSize.wInches,
            hInches: varSize.hInches,
            matches: [],
          };
        }

        padSizeGroups[key].matches.push({
          variantId: variant.id,
          padTitle: product.title,
          surface: product.surface,
          size: variant.title,
          price: variant.price,
          available: variant.available,
          compareAtPrice: variant.compare_at_price,
          url: product.url,
        });
      }
    }

    // Sort pad sizes by area (smallest first)
    var padSizeKeys = Object.keys(padSizeGroups).sort(function (a, b) {
      var aG = padSizeGroups[a];
      var bG = padSizeGroups[b];
      return (aG.wInches * aG.hInches) - (bG.wInches * bG.hInches);
    });

    if (!padSizeKeys.length) return;

    // Build the pad size dropdown
    var selectHtml = '<div class="rug-pad-upsell__size-row">';
    selectHtml += '<label for="' + SIZE_SELECT_ID + '" class="rug-pad-upsell__size-label">Pad size</label>';
    selectHtml += '<select id="' + SIZE_SELECT_ID + '" class="rug-pad-upsell__size-select">';
    selectHtml += '<option value="">Select a size</option>';
    for (var s = 0; s < padSizeKeys.length; s++) {
      var grp = padSizeGroups[padSizeKeys[s]];
      selectHtml += '<option value="' + padSizeKeys[s] + '">' + grp.label + '</option>';
    }
    selectHtml += '</select>';
    selectHtml += '</div>';

    // Insert dropdown before options container
    optionsEl.insertAdjacentHTML('beforebegin', selectHtml);
    var sizeSelect = document.getElementById(SIZE_SELECT_ID);

    // When dropdown changes, render pad type options
    sizeSelect.addEventListener('change', function () {
      var selectedKey = sizeSelect.value;
      if (!selectedKey || !padSizeGroups[selectedKey]) {
        optionsEl.innerHTML = '';
        return;
      }
      renderOptions(padSizeGroups[selectedKey].matches, optionsEl);
    });

    // Show the section
    container.style.display = '';
  }

  // ── Initialization ────────────────────────────────────────────────────
  var initializedContainer = null;
  var pollInterval = null;

  function init() {
    var container = document.getElementById(CONTAINER_ID);
    var optionsEl = document.getElementById(OPTIONS_ID);
    var padDataEl = document.getElementById(PAD_DATA_ID);

    if (!container || !optionsEl || !padDataEl) return;
    if (container === initializedContainer) return;
    initializedContainer = container;

    if (pollInterval) clearInterval(pollInterval);

    var padProducts;
    try {
      padProducts = JSON.parse(padDataEl.textContent);
    } catch (e) {
      return;
    }
    if (!padProducts || !padProducts.length) return;

    setup(container, optionsEl, padProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:section:load', init);

  var bodyObserver = new MutationObserver(function () {
    var container = document.getElementById(CONTAINER_ID);
    if (container && container !== initializedContainer) {
      init();
    }
  });
  bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
